import React, { FC, useState } from 'react';

import { Table } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { TableParams } from '@app/models/interfaces';
import { useWindowSize } from '@app/services/hooks/useWindowSize';

import { useGetEmployeeInvitesQuery } from '../../../../hooks';

import { TableActionMenu } from './components/TableActionMenu';

import { baseColumns } from './data/constants';
import { Container } from './styles';

interface IProps {
  setPagination: (newCurrent: number, newPageSize: number) => void;
  current: number;
  pageSize: number;
}

export const InvitesTable: FC<IProps> = ({ current, pageSize, setPagination }) => {
  const commonT = useTranslation(NSKeys.common);
  const employeesT = useTranslation(NSKeys.employees);
  const { innerHeight } = useWindowSize();
  const { data, isLoading } = useGetEmployeeInvitesQuery({
    offset: (current - 1) * pageSize,
    limit: pageSize,
  });

  return (
    <Container>
      <Table
        loading={isLoading}
        dataSource={data?.items}
        rowKey="pk"
        className="tableClassname"
        columns={[
          ...baseColumns.map((el) => ({ ...el, title: employeesT.t(el.title as any) })),
          {
            key: 'action',
            width: 60,
            fixed: 'right',
            onCell: () => {
              return {
                onClick: (e) => console.log(e.stopPropagation()),
              };
            },
            render: (_, cell) => <TableActionMenu invitation_uuid={cell.uuid} />,
          },
        ]}
        pagination={{
          current: current,
          pageSize: pageSize,
          total: data?.total,
          showQuickJumper: true,
          showSizeChanger: true,
          position: ['bottomCenter'],
          showTotal: (total, range) => `${range[0]}-${range[1]} ${commonT.t('paginationOf')} ${total}`,
          onChange: (newPage, newSize) => {
            setPagination(newPage, newSize);
          },
        }}
        rowClassName="cursorPointer"
        scroll={{ y: innerHeight - 300, x: true }}
        style={{ overflow: 'auto' }}
      />
    </Container>
  );
};
